module.exports = __webpack_public_path__ + "img/qf_aircraft.5f14c2ba.jpg";